import React from 'react';
import css from './css.module.less';
import { useGetCurrentEditingUsr } from 'src/hooks/useGetCurrentEditingUsr';
import { Avatar } from 'antd';
import WhiteBackgroundTooltip, {
  TooltipContainer,
  TooltipContent,
} from '@/src/components/GlobalTooltip/WhiteBackgroundTooltip';
const EditingUsers = () => {
  const { users } = useGetCurrentEditingUsr();

  const isLargerThan4 = users.length > 4;
  const first3 = users.slice(0, 3);
  const collapsed = users.slice(3, users.length);

  return (
    <div className={css.container}>
      {isLargerThan4 ? (
        <React.Fragment>
          {first3.map((i) => {
            const { connectionId } = i;
            return <DisplayAvatar data={i} key={connectionId} />;
          })}
          <CollapseAvatar data={collapsed} />
        </React.Fragment>
      ) : (
        <React.Fragment>
          {users.map((i) => {
            const { connectionId } = i;
            return <DisplayAvatar data={i} key={connectionId} />;
          })}
        </React.Fragment>
      )}
    </div>
  );
};
export default EditingUsers;

const DisplayAvatar = ({ data }) => {
  const { processedName, userName, contactInfo } = data;
  return (
    <WhiteBackgroundTooltip
      //color={'#000'}
      title={
        <UserCard
          processedName={processedName}
          userName={userName}
          contactInfo={contactInfo}
        />
      }
      placement='bottom'>
      {' '}
      <Avatar className={css.topHeaderAvatar} size={40}>
        {processedName}
      </Avatar>
    </WhiteBackgroundTooltip>
  );
};

const CollapseAvatar = ({ data }) => {
  const length = data.length;
  return (
    <WhiteBackgroundTooltip
      //color={'#000'}
      title={
        <React.Fragment>
          {data.map((i, index) => {
            const { connectionId } = i;
            const isFirst = index === 0;
            const isLast = index === length - 1;
            return (
              <UserCard
                {...i}
                key={connectionId}
                containerClassName={css.containerClassName}
                {...(isFirst
                  ? {
                      containerStyle: {
                        paddingTop: 0,
                      },
                    }
                  : {})}
                {...(isLast
                  ? {
                      containerStyle: {
                        paddingBottom: 0,
                        borderBottom: 'none',
                      },
                    }
                  : {})}
              />
            );
          })}
        </React.Fragment>
      }
      placement='bottom'>
      <Avatar className={css.collapseAvatar} size={40}>
        +{length}
      </Avatar>
    </WhiteBackgroundTooltip>
  );
};

const UserCard = (props) => {
  const {
    processedName,
    userName,
    contactInfo,
    containerClassName,
    containerStyle,
  } = props;
  return (
    <TooltipContainer className={containerClassName} style={containerStyle}>
      <TooltipContent className={css.avatarContent}>
        <Avatar className={css.topHeaderAvatar} size={40}>
          {processedName}
        </Avatar>

        <div>
          <div className={css.userName}>{userName}</div>
          <div className={css.contactInfo}>{contactInfo}</div>
        </div>
      </TooltipContent>
    </TooltipContainer>
  );
};
